import React, { FC } from "react";
import NavigationItem, { NavItemType } from "./NavigationItem";
import { NAVIGATION_DEMO } from "data/navigation";

export interface NavigationProps {
  navigations?: NavItemType[];
  className?: string;
}

const Navigation: FC<NavigationProps> = ({ navigations = NAVIGATION_DEMO,className = "" }) => {
  return (
    <ul className={`nc-Navigation hidden lg:flex lg:flex-wrap lg:items-center lg:space-x-1 relative ${className}`}>
      {navigations.map((item) => (
        <NavigationItem key={item.id} menuItem={item} />
      ))}
    </ul>
  );
};

export default Navigation;
